export default {"src":"/_next/static/media/sin.bd8a9f41.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};